<template>
  <div class="home mt-5">
    <b-container>

      <b-button variant="link" class="mb-3 p-0" @click="$router.push({ name: 'chat-monitor' })">
        &larr; Voltar ao Monitor
      </b-button>

      <b-card v-if="conversation" class="shadow-sm mb-3">
        <b-row>
          <b-col md="3">
            <div class="text-muted small">Usuário</div>
            <div class="font-weight-bold">
              {{ conversation.user ? (conversation.user.name || conversation.user.email) : '-' }}
            </div>
          </b-col>
          <b-col md="2">
            <div class="text-muted small">Agente</div>
            <div class="font-weight-bold">{{ conversation.agentId }}</div>
          </b-col>
          <b-col md="2">
            <div class="text-muted small">Modelo</div>
            <div>{{ conversation.lastModel || '-' }}</div>
          </b-col>
          <b-col md="2">
            <div class="text-muted small">Tokens Total</div>
            <div class="font-weight-bold">{{ formatNumber(conversation.totalTokens) }}</div>
          </b-col>
          <b-col md="3">
            <div class="text-muted small">Data</div>
            <div>{{ conversation.createdAt | moment('DD/MM/YYYY HH:mm') }}</div>
          </b-col>
        </b-row>
      </b-card>

      <b-card v-if="conversation" class="shadow-sm" no-body>
        <b-card-header>
          Mensagens ({{ conversation.messages ? conversation.messages.length : 0 }})
        </b-card-header>
        <div class="conversation-messages p-3">
          <div v-for="msg in (conversation.messages || [])" :key="msg.id"
            :class="['conv-message', msg.role]">
            <div class="conv-message-header">
              <b-badge :variant="msg.role === 'user' ? 'primary' : 'secondary'">
                {{ msg.role === 'user' ? 'Usuário' : 'Assistente' }}
              </b-badge>
              <span class="text-muted small ml-2">{{ msg.createdAt | moment('HH:mm:ss') }}</span>
              <span v-if="msg.totalTokens" class="text-muted small ml-2">
                ({{ formatNumber(msg.totalTokens) }} tokens)
              </span>
            </div>
            <div class="conv-message-content mt-1">
              <div v-if="msg.role === 'assistant'" v-html="renderMarkdown(msg.content)"></div>
              <pre v-else class="mb-0" style="white-space: pre-wrap; font-family: inherit;">{{ msg.content }}</pre>
            </div>
          </div>
        </div>
      </b-card>

      <div v-if="isLoading" class="text-center my-4">
        <b-spinner></b-spinner>
        <div>Carregando...</div>
      </div>

    </b-container>
  </div>
</template>

<script>
import { getConversation } from '../../services/adminChat';
import { marked } from 'marked';
import DOMPurify from 'dompurify';

export default {
  name: 'ConversationDetail',
  data() {
    return {
      conversation: null,
      isLoading: false,
    };
  },
  async mounted() {
    this.isLoading = true;
    try {
      this.conversation = await getConversation(this.$route.params.id);
    } catch (err) {
      this.$toast.error('Erro ao carregar conversa.');
    } finally {
      this.isLoading = false;
    }
  },
  methods: {
    renderMarkdown(content) {
      if (!content) return '';
      // Same sanitization as ChatMessage.vue to strip OpenAI citation artifacts
      const cleaned = content
        .replace(/【\s*turn\d+file\d+\s*】/g, '')
        .replace(/\bturn\d+file\d+\b/g, '')
        .replace(/\[filecite[^\]]*\]/gi, '')
        .replace(/[【】]+/g, '')
        .replace(/\s{2,}/g, ' ')
        .trim();
      const html = marked.parse(cleaned);
      return DOMPurify.sanitize(html, {
        USE_PROFILES: { html: true },
        ADD_ATTR: ['target', 'rel'],
      });
    },
    formatNumber(n) {
      if (!n) return '0';
      return parseInt(n).toLocaleString('pt-BR');
    },
  },
};
</script>

<style scoped>
.conversation-messages {
  max-height: 70vh;
  overflow-y: auto;
}

.conv-message {
  margin-bottom: 16px;
  padding: 8px 12px;
  border-radius: 8px;
}

.conv-message.user {
  background-color: #e8f0fe;
}

.conv-message.assistant {
  background-color: #f5f5f5;
}

.conv-message-content {
  font-size: 13px;
  line-height: 1.5;
}
</style>
